import React from 'react';
import {
  Card,
  CardBody,
  CardHeader,
} from "../components";

function Deskripsi() {
  return (
    <>
      <div className="page-heading">
        <h3>Deskripsi Aplikasi</h3>
        <p className="text-subtitle text-muted">Portal Landing Page BPM Unismuh Makassar</p>
      </div>
      
      <div className="page-content">
        {/* Tentang Aplikasi */}
        <section className="row">
          <div className="col-12">
            <Card>
              <CardHeader title="Tentang Aplikasi" className="px-3 pt-3" />
              <CardBody>
                <p className="text-justify mb-3">
                  <strong>Portal Landing Page BPM Unismuh Makassar</strong> adalah aplikasi web berbasis React yang 
                  menyediakan akses terpusat ke berbagai sistem informasi dan aplikasi yang dikelola oleh Badan 
                  Penjaminan Mutu Universitas Muhammadiyah Makassar.
                </p>
                <p className="text-justify mb-3">
                  Aplikasi ini dirancang dengan antarmuka modern dan user-friendly menggunakan card-based UI yang 
                  responsif, memudahkan pengguna untuk mengakses berbagai aplikasi seperti MONEV & AMI, Tracer Study, 
                  ISO 21001:2018, Survey, dan sistem lainnya dengan mudah dan cepat.
                </p>
                <p className="text-justify mb-0">
                  Dengan sistem navigasi hierarkis, pengguna dapat menjelajahi menu utama yang memiliki sub-aplikasi, 
                  semuanya diorganisir dengan rapi dan intuitif.
                </p>
              </CardBody>
            </Card>
          </div>
        </section>

        {/* Fitur Utama */}
        <section className="row">
          <div className="col-12">
            <Card>
              <CardHeader title="Fitur Utama" className="px-3 pt-3" />
              <CardBody>
                <div className="row">
                  <div className="col-12 col-md-6 mb-3">
                    <div className="d-flex align-items-start">
                      <div className="flex-shrink-0 me-3">
                        <i className="bi bi-grid-3x3-gap-fill text-primary fs-2"></i>
                      </div>
                      <div>
                        <h6 className="mb-2 fw-bold">Card-Based Interface</h6>
                        <p className="text-muted mb-0 small">
                          Tampilan modern dengan card untuk setiap aplikasi yang mudah diakses dan dipahami.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-6 mb-3">
                    <div className="d-flex align-items-start">
                      <div className="flex-shrink-0 me-3">
                        <i className="bi bi-diagram-3-fill text-success fs-2"></i>
                      </div>
                      <div>
                        <h6 className="mb-2 fw-bold">Hierarchical Menu</h6>
                        <p className="text-muted mb-0 small">
                          Sistem menu parent-child yang terorganisir dengan baik untuk navigasi yang intuitif.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-6 mb-3">
                    <div className="d-flex align-items-start">
                      <div className="flex-shrink-0 me-3">
                        <i className="bi bi-phone-fill text-info fs-2"></i>
                      </div>
                      <div>
                        <h6 className="mb-2 fw-bold">Responsive Design</h6>
                        <p className="text-muted mb-0 small">
                          Tampilan optimal di berbagai perangkat: desktop, tablet, dan smartphone.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-6 mb-3">
                    <div className="d-flex align-items-start">
                      <div className="flex-shrink-0 me-3">
                        <i className="bi bi-link-45deg text-warning fs-2"></i>
                      </div>
                      <div>
                        <h6 className="mb-2 fw-bold">SEO-Friendly URLs</h6>
                        <p className="text-muted mb-0 small">
                          URL deskriptif yang mudah diingat dan ramah mesin pencari.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-6 mb-3">
                    <div className="d-flex align-items-start">
                      <div className="flex-shrink-0 me-3">
                        <i className="bi bi-lightning-charge-fill text-danger fs-2"></i>
                      </div>
                      <div>
                        <h6 className="mb-2 fw-bold">Fast Loading</h6>
                        <p className="text-muted mb-0 small">
                          Dibangun dengan Vite untuk performa maksimal dan loading yang cepat.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-md-6 mb-3">
                    <div className="d-flex align-items-start">
                      <div className="flex-shrink-0 me-3">
                        <i className="bi bi-database-fill-gear text-purple fs-2"></i>
                      </div>
                      <div>
                        <h6 className="mb-2 fw-bold">Dynamic Content</h6>
                        <p className="text-muted mb-0 small">
                          Konten menu dinamis dari database melalui REST API yang dapat dikelola dengan mudah.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>
        </section>

        {/* Teknologi & Spesifikasi */}
        <section className="row">
          <div className="col-12 col-lg-6">
            <Card>
              <CardHeader title="Teknologi" className="px-3 pt-3" />
              <CardBody>
                <h6 className="mb-3 fw-bold text-primary">Frontend</h6>
                <ul className="mb-4">
                  <li className="mb-2">
                    <strong>React 17.0.2</strong> - JavaScript library untuk UI
                  </li>
                  <li className="mb-2">
                    <strong>Vite</strong> - Build tool modern dengan HMR cepat
                  </li>
                  <li className="mb-2">
                    <strong>Bootstrap 5.2.0</strong> - CSS framework responsif
                  </li>
                  <li className="mb-2">
                    <strong>React Router 6</strong> - Client-side routing
                  </li>
                  <li className="mb-2">
                    <strong>Axios</strong> - HTTP client untuk API calls
                  </li>
                  <li className="mb-2">
                    <strong>SCSS/Sass</strong> - CSS preprocessor
                  </li>
                </ul>

                <h6 className="mb-3 fw-bold text-success">Backend</h6>
                <ul className="mb-0">
                  <li className="mb-2">
                    <strong>PHP 8.3 + FPM</strong> - Backend runtime
                  </li>
                  <li className="mb-2">
                    <strong>Slim Framework 4</strong> - REST API framework
                  </li>
                  <li className="mb-2">
                    <strong>MySQL/MariaDB</strong> - Database management
                  </li>
                  <li className="mb-2">
                    <strong>Apache 2.4</strong> - Web server
                  </li>
                </ul>
              </CardBody>
            </Card>
          </div>

          <div className="col-12 col-lg-6">
            <Card>
              <CardHeader title="Spesifikasi" className="px-3 pt-3" />
              <CardBody>
                <h6 className="mb-3 fw-bold text-info">Performance</h6>
                <ul className="mb-4">
                  <li className="mb-2">Bundle Size: ~143 KB (gzipped)</li>
                  <li className="mb-2">First Contentful Paint: &lt; 1.5s</li>
                  <li className="mb-2">Time to Interactive: &lt; 3s</li>
                  <li className="mb-2">API Response Time: &lt; 200ms</li>
                </ul>

                <h6 className="mb-3 fw-bold text-warning">SEO & PWA</h6>
                <ul className="mb-4">
                  <li className="mb-2">
                    <i className="bi bi-check-circle-fill text-success me-2"></i>
                    Meta tags lengkap
                  </li>
                  <li className="mb-2">
                    <i className="bi bi-check-circle-fill text-success me-2"></i>
                    Open Graph support
                  </li>
                  <li className="mb-2">
                    <i className="bi bi-check-circle-fill text-success me-2"></i>
                    Sitemap.xml
                  </li>
                  <li className="mb-2">
                    <i className="bi bi-check-circle-fill text-success me-2"></i>
                    PWA manifest
                  </li>
                </ul>

                <h6 className="mb-3 fw-bold text-danger">Security</h6>
                <ul className="mb-0">
                  <li className="mb-2">
                    <i className="bi bi-shield-check text-success me-2"></i>
                    HTTPS enforcement
                  </li>
                  <li className="mb-2">
                    <i className="bi bi-shield-check text-success me-2"></i>
                    CORS configured
                  </li>
                  <li className="mb-2">
                    <i className="bi bi-shield-check text-success me-2"></i>
                    XSS protection
                  </li>
                  <li className="mb-2">
                    <i className="bi bi-shield-check text-success me-2"></i>
                    SQL prepared statements
                  </li>
                </ul>
              </CardBody>
            </Card>
          </div>
        </section>

        {/* Aplikasi yang Tersedia */}
        <section className="row">
          <div className="col-12">
            <Card>
              <CardHeader title="Aplikasi yang Tersedia" className="px-3 pt-3" />
              <CardBody>
                <p className="mb-4">
                  Portal ini menyediakan akses ke <strong>14 sistem aplikasi</strong> yang terbagi dalam 
                  <strong> 6 kategori utama</strong>:
                </p>

                <div className="row">
                  <div className="col-12 col-md-6 mb-3">
                    <div className="bg-light p-3 rounded">
                      <h6 className="mb-2 fw-bold">
                        <i className="bi bi-globe2 text-primary me-2"></i>
                        WEBSITE
                      </h6>
                      <p className="text-muted mb-0 small">Portal website resmi BPM</p>
                    </div>
                  </div>

                  <div className="col-12 col-md-6 mb-3">
                    <div className="bg-light p-3 rounded">
                      <h6 className="mb-2 fw-bold">
                        <i className="bi bi-file-earmark-bar-graph text-success me-2"></i>
                        LAPORAN KINERJA
                      </h6>
                      <p className="text-muted mb-2 small">2 aplikasi:</p>
                      <ul className="mb-0 small">
                        <li>Pelaporan Kinerja </li>
                        <li>Dokumen Akreditasi</li>
                      </ul>
                    </div>
                  </div>

                  <div className="col-12 col-md-6 mb-3">
                    <div className="bg-light p-3 rounded">
                      <h6 className="mb-2 fw-bold">
                        <i className="bi bi-clipboard-check text-info me-2"></i>
                        MONEV & AMI
                      </h6>
                      <p className="text-muted mb-2 small">4 aplikasi:</p>
                      <ul className="mb-0 small">
                        <li>TPM Prodi</li>
                        <li>Gugus Kendali Mutu</li>
                        <li>Auditor Prodi</li>
                        <li>Auditor Unit Kerja</li>
                      </ul>
                    </div>
                  </div>

                  <div className="col-12 col-md-6 mb-3">
                    <div className="bg-light p-3 rounded">
                      <h6 className="mb-2 fw-bold">
                        <i className="bi bi-mortarboard text-warning me-2"></i>
                        TRACER STUDY
                      </h6>
                      <p className="text-muted mb-2 small">3 aplikasi:</p>
                      <ul className="mb-0 small">
                        <li>Admin Tracer Study</li>
                        <li>Kuesioner Alumni</li>
                        <li>Kuesioner Pengguna</li>
                      </ul>
                    </div>
                  </div>

                  <div className="col-12 col-md-6 mb-3">
                    <div className="bg-light p-3 rounded">
                      <h6 className="mb-2 fw-bold">
                        <i className="bi bi-award text-danger me-2"></i>
                        ISO 21001:2018
                      </h6>
                      <p className="text-muted mb-2 small">2 aplikasi:</p>
                      <ul className="mb-0 small">
                        <li>Admin ISO</li>
                        <li>Auditor ISO</li>
                      </ul>
                    </div>
                  </div>

                  <div className="col-12 col-md-6 mb-3">
                    <div className="bg-light p-3 rounded">
                      <h6 className="mb-2 fw-bold">
                        <i className="bi bi-clipboard-data text-purple me-2"></i>
                        SURVEY
                      </h6>
                      <p className="text-muted mb-2 small">2 aplikasi:</p>
                      <ul className="mb-0 small">
                        <li>Survey Unit Kerja</li>
                        <li>Survey Profesi Dokter</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>
        </section>

        {/* Developer Info */}
        <section className="row">
          <div className="col-12">
            <Card>
              <CardHeader title="Informasi Pengembang" className="px-3 pt-3" />
              <CardBody>
                <div className="row align-items-center">
                  <div className="col-12 col-md-8 mb-3 mb-md-0">
                    <p className="mb-2">
                      <strong>Versi:</strong> 0.1.1-alpha4
                    </p>
                    <p className="mb-2">
                      <strong>Dikembangkan oleh:</strong> Badan Penjaminan Mutu - Unismuh Makassar
                    </p>
                  </div>
                  <div className="col-12 col-md-4 text-md-end">
                    <div className="alert alert-info mb-0" role="alert">
                      <i className="bi bi-info-circle me-2"></i>
                      <strong>Production Ready</strong>
                      <div className="small mt-1">Deployed: November 2025</div>
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>
        </section>
      </div>
    </>
  );
}

export default Deskripsi;
